import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMacbook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconMacbook"><Path d="M22.25 17C22.6642 17 23 17.3358 23 17.75V18.25C23 19.7688 21.7688 21 20.25 21H3.75C2.23122 21 1 19.7688 1 18.25V17.75C1 17.3358 1.33579 17 1.75 17H22.25Z" fill="currentColor"/><Path d="M18.25 3C19.7688 3 21 4.23122 21 5.75V15.5H3V5.75C3 4.23122 4.23122 3 5.75 3H18.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMacbook;
